import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {CommonModule, DOCUMENT} from "@angular/common";
import {CustomSearchInputComponent} from "../../elements/inputs/custom-search-input/custom-search-input.component";
import {AlgoliaService} from "../../../services/algolia.service";
import {WordpressService} from "../../../services/wordpress.service";
import {ListPagesSectionComponent} from "../../modules/list-pages-section/list-pages-section.component";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {ActivatedRoute} from "@angular/router";
import {ThemeService} from "../../../services/theme.service";
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {SynapiItemTypes} from "../../../models/Synapi/enums/SynapiItemTypes";
import {SearchResult} from "../../../models/Misc/SearchResult";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";

@Component({
  selector: 'search',
  standalone: true,
  imports: [
    CustomSearchInputComponent, CommonModule, ListPagesSectionComponent, TinyPostComponent, TinyPostsFromIdsPipe, SynapiListItemsComponent
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent implements OnInit{
  @Input() textsearch: string = "";
  public featured_pages : number[] = [];
  public keywords : string[] = [];
  public template : 'home'|'page' = 'page';
  public searchResult = new SearchResult();
  public total = 0;
  public loading = false;
  public displayAll = true;
  public displayActivities = false;
  public displaySuggestions = false;
  public displayRestaurants = false;
  public displayAccommodations = false;
  public displayEvents = false;
  public displayStays = false;
  public displayOthers = false;
  public displayServices = false;
  public linkCopied = false;
  @Input() displaySearch = false;
  @Input() headerScrolled = false;
  @Output() displaySearchChange = new EventEmitter<boolean>();
  constructor(public algoliaService: AlgoliaService, public wordpressService: WordpressService, private themeService: ThemeService){}

  ngOnInit() {
    this.wordpressService.getSearchData().then((data)=>{
      this.keywords = data.keywords ? data.keywords.split(',').map((k)=>k.trim()) : [];
      this.featured_pages = data.featured_pages;
    });
    this.themeService.template$.subscribe((template)=>{
      this.template = template;
    });
    if(this.textsearch!=""){
      const search = this.textsearch;
      this.onSearchChange(search);
    }
  }

  onKeywordClick(keyword: string){
    this.textsearch = keyword;
    this.onSearchChange(keyword);
  }

  onSearchChange($event: string) {
    this.textsearch = $event;
    this.loading = true;
    this.algoliaService.search($event).then((hits)=>{
      this.searchResult = new SearchResult();
      if(hits){
        this.total = 0;
        hits.map((hit)=>{
          this.sortResult(hit);
        })
      }
      this.loading = false;
    });
  }

  onSearchFocus(){
    this.displaySearch = true;
    this.displaySearchChange.emit(true);
  }

  onCloseClick(){
    this.displaySearch = false;
    this.displaySearchChange.emit(false);
  }

  sortResult(hit : any){
    const t = SynapiItemTypes;

    if(hit.Type === "WP_PAGE"){
      this.searchResult.suggestions.push(hit.Id);
      this.total++;
    } else if(hit.Type === "FICHE_SIT") {
      this.total++;
      this.searchResult.all.push(hit.Id);
      switch(hit.TypeFiche){
        case t.ACTIVITE:
        case t.PATRIMOINE_CULTUREL:
        case t.PATRIMOINE_NATUREL:
          this.searchResult.activities.push(hit.Id);
          break;
        case t.RESTAURATION:
        case t.DEGUSTATION:
          this.searchResult.restaurants.push(hit.Id);
          break;
        case t.HEBERGEMENT_COLLECTIF:
        case t.HEBERGEMENT_LOCATIF:
        case t.HOTELLERIE:
        case t.HOTELLERIE_PLEIN_AIR:
          this.searchResult.accommodations.push(hit.Id);
          break;
        case t.FETE_ET_MANIFESTATION:
          this.searchResult.events.push(hit.Id);
          break;
        case t.COMMERCE_ET_SERVICE:
          this.searchResult.services.push(hit.Id);
          break;
        case t.SEJOUR_PACKAGE:
          this.searchResult.stays.push(hit.Id);
          break;
        default:
          this.searchResult.others.push(hit.Id);
      }

    }
  }

  setDisplay(display:string){
    this.displayAll = false;
    this.displaySuggestions = false;
    this.displayActivities = false;
    this.displayAccommodations = false;
    this.displayRestaurants = false;
    this.displayStays = false;
    this.displayServices = false;
    this.displayEvents = false;
    this.displayOthers = false;
    // @ts-ignore
    this[display] = true;
  }



}
